(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6937],{

/***/ 37296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(24782);

/***/ }),

/***/ 56805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta/jobs",
      function () {
        return __webpack_require__(8550);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ FastCardImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48876);
/* harmony import */ var src_app_globalStyles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(458);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 10px;\n  margin-top: ",
        ";\n  width: 426px;\n\n  @media (max-width: ",
        ") {\n    width: 200px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var FastCardImage = function(param) {
    var src = param.src, alt = param.alt, width = param.width, height = param.height, solo = param.solo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FastCardImageWrapper, {
        solo: solo,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            src: src,
            width: width,
            height: height,
            alt: alt,
            style: {
                outline: "1px solid black",
                outlineOffset: "-1px"
            }
        })
    });
};
var FastCardImageWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5f7ddb00-0"
})(_templateObject(), function(props) {
    return props.solo ? "36px" : "16px";
}, src_app_globalStyles__WEBPACK_IMPORTED_MODULE_2__/* .DEVICE.small */ .T.small);


/***/ }),

/***/ 8550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Jobs; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2413);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(37296);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(26235);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(40974);
// EXTERNAL MODULE: ./src/components/Splash/CardImage.tsx
var CardImage = __webpack_require__(74369);
// EXTERNAL MODULE: ./src/components/Splash/Footer.tsx
var Footer = __webpack_require__(45635);
// EXTERNAL MODULE: ./src/components/Splash/Header.tsx
var Header = __webpack_require__(84366);
// EXTERNAL MODULE: ./src/components/Splash/Layout/PageContainer.tsx
var PageContainer = __webpack_require__(92377);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(94785);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(44725);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(48876);
;// CONCATENATED MODULE: ./src/components/Splash/Layout/PostPill.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #cccccc;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #904d4d;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var LDPostPill = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySpan, {
                children: "[["
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RedSpan, {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GraySpan, {
                children: "]]"
            })
        ]
    });
};
var GraySpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1af0c38f-0"
})(_templateObject());
var RedSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-1af0c38f-1"
})(_templateObject1());

// EXTERNAL MODULE: ./src/components/Splash/Layout/Typography.tsx
var Typography = __webpack_require__(91865);
// EXTERNAL MODULE: ./src/components/Splash/LDBlock.tsx
var LDBlock = __webpack_require__(91881);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(30440);
;// CONCATENATED MODULE: ./src/pages/meta/jobs/index.tsx
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 











function Jobs() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Vienna Hypertext - Jobs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.png"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageContainer/* LDPageContainer */.R, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* LDHeader */.hn, {
                            text: "JOB BOARD",
                            leftItem: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: lib/* isElectron */.d ? "/meta/index.html" : constants/* AppRoutes.Meta */.$w.Meta,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* HeaderLink */.KS, {
                                    style: {
                                        textAlign: "left",
                                        marginLeft: "20px"
                                    },
                                    children: "HOME"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDBlock */.zB, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockHeading */.nL, {
                                    children: "About"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockParagraph */.yC, {
                                    children: "Vienna Hypertext is a software company building an app for working with ideas."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockParagraph */.yC, {
                                    children: [
                                        "We are interested in computing ideas from the '60s and '70s, the kind that saw the computer as a tool for the intellectual and artist. One such idea, very influential, is",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDVLink */.tC, {
                                            href: "https://en.wikipedia.org/wiki/Project_Xanadu",
                                            children: "Project Xanadu"
                                        }),
                                        ", whose creator coined the term hypertext."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockParagraph */.yC, {
                                    children: [
                                        "At root, we are seeking to reclaim the computer as a tool for thought by reviving ideas that came before their time. We believe in",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDVLink */.tC, {
                                            href: "https://vienna.earth/plate/vht/Computer%20Renaissance",
                                            children: "Computer Renaissance"
                                        }),
                                        ", and see ourselves at the intersection of technology and philosophy."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LDBlock/* LDSectionBlock */.qB, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDSectionBlockHeading */.CE, {
                                children: "Open Positions"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(constants/* AppRoutes.Jobs */.$w.Jobs, "/frontend"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDLinkBlock */.sw, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockHeading */.nL, {
                                        children: [
                                            "Frontend Engineer ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LDPostPill, {
                                                children: "UPDATED"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage/* FastCardImage */.n, {
                                        src: "https://prod-vht-image-bucket.s3.amazonaws.com/fitzcarraldo.jpg",
                                        width: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(constants/* AppRoutes.Jobs */.$w.Jobs, "/full-stack"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDLinkBlock */.sw, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockHeading */.nL, {
                                        children: [
                                            "Full Stack Engineer ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LDPostPill, {
                                                children: "UPDATED"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage/* FastCardImage */.n, {
                                        src: "https://prod-vht-image-bucket.s3.amazonaws.com/guysinfield.png",
                                        width: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(constants/* AppRoutes.Jobs */.$w.Jobs, "/design"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDLinkBlock */.sw, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* LDBlockHeading */.nL, {
                                        children: [
                                            "Designer ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LDPostPill, {
                                                children: "UPDATED"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage/* FastCardImage */.n, {
                                        src: "https://prod-vht-image-bucket.s3.amazonaws.com/architecten.jpg",
                                        width: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(constants/* AppRoutes.Jobs */.$w.Jobs, "/byoj"),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LDBlock/* LDLinkBlock */.sw, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* LDBlockHeading */.nL, {
                                        children: "Build Your Own Job"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImage/* FastCardImage */.n, {
                                        src: "https://prod-vht-image-bucket.s3.amazonaws.com/hippies.jpg",
                                        width: "100%"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* LDFooter */.v, {})
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2349,9774,2888,179], function() { return __webpack_exec__(56805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);